import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import ClassificacaoTiposDocumentoModal from "./ClassificacaoTiposDocumentoModal";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function ClassificacaoTiposDocumento() {
  const { toast, confirm } = useFeedback();
  const [lista, setLista] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const token = localStorage.getItem("authToken");
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const exclusoesEmAndamento = useRef(new Set());

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Nome", accessor: "nome" },
    { Header: "Descrição", accessor: "descricao" },
    { Header: "Situação", accessor: "situacao" },
  ];

  const fetchLista = useCallback(() => {
    if (!entidadeID || !token) return;
    api
      .get(`${BASE_URL}/api/classificacaoTiposDocumento/ListarClassificacaoTiposDocumento/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setLista(Array.isArray(response.data?.data) ? response.data.data : []);
      })
      .catch((error) => {
        console.error("Erro ao listar classificação tipos documento:", error);
      });
  }, [token, entidadeID]);

  useEffect(() => {
    fetchLista();
  }, [fetchLista]);

  const handleEdit = (item) => {
    setSelected(item);
    setShowModal(true);
  };

  const handleAdd = () => {
    setSelected(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelected(null);
    fetchLista();
  };

  const handleExcluir = async (item) => {
    if (exclusoesEmAndamento.current.has(item.id)) return;
    exclusoesEmAndamento.current.add(item.id);

    try {
      const ok = await confirm(`Tem certeza que deseja excluir a classificação "${item.nome}"?`);
      if (!ok) return;

      await api.delete(
        `${BASE_URL}/api/classificacaoTiposDocumento/ExcluirClassificacaoTiposDocumento/${item.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchLista();
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(error.response.data?.message || "Esta classificação está sendo utilizada.");
        return;
      }

      console.error("Erro ao excluir classificação:", error);
      toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
    } finally {
      exclusoesEmAndamento.current.delete(item.id);
    }
  };

  return (
    <div>
      <PageHeader titulo="Classificação Tipos de Documento" path="/ClassificacaoTiposDocumento" />

      <GridPadrao
        columns={columns}
        data={lista}
        onEdit={handleEdit}
        onAdd={handleAdd}
        addDataTour="classificacao-tipos-documento-adicionar"
        onInactivate={handleExcluir}
      />

      <ClassificacaoTiposDocumentoModal
        show={showModal}
        handleClose={handleClose}
        item={selected}
        idEntidade={entidadeID}
        fetchLista={fetchLista}
      />
    </div>
  );
}

export default ClassificacaoTiposDocumento;
